import { useMutation, InfiniteData } from 'react-query';
import produce from 'immer';
import message from 'antd/es/message';

import { queryClient, request, toastError } from '@/utils';
import { NftToken } from '@/views/NFT';

import { NftInCollection } from '../types';

export const useCollectionRefresh = () => {
  return useMutation(
    (params: { chain_id: string; nft_id: string }) => {
      return request.post<{ nft: NftToken }>('/collection/refresh_nft_metadata', params);
    },
    {
      onError(error: any) {
        toastError(error, 'failed to fetch, please try later');
      },
    },
  );
};

export const updateCollectionNftInfo = (data?: NftToken) => {
  if (!data?.id) {
    return;
  }

  queryClient.setQueriesData(
    ['/collection/nft_list'],
    (pre?: InfiniteData<{ nft_list: NftInCollection[] }>) => {
      if (!pre) {
        return pre!;
      }

      return produce(pre, draft => {
        // 使用 find 提前退出循环
        draft.pages.find(x => {
          const record = x.nft_list?.find((n: NftInCollection) => n.id === data.id);

          if (record) {
            Object.assign(record, data);

            return true;
          }

          return false;
        });

        return draft;
      });
    },
  );

  message.success('Metadata updated');
};
